import { SvgIcon, SvgIconProps } from "@mui/material";

export const SignatureIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <rect width="24" height="24" fill="#fff" rx="4" />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m19 16.5-1.677-1.495a.385.385 0 0 0-.423-.076.392.392 0 0 0-.17.15.409.409 0 0 0-.063.22v.4a.812.812 0 0 1-.228.567.767.767 0 0 1-.55.234h-1.556a.767.767 0 0 1-.55-.234.812.812 0 0 1-.227-.566c0-2.036-3.105-3.176-6.612-3.2-.515 0-1.01.21-1.374.585A2.03 2.03 0 0 0 5 14.5c0 .53.205 1.04.57 1.414.364.375.859.586 1.374.586 3.23 0 3.691-9.037 4.44-10.8.127-.299.322-.56.569-.763a1.892 1.892 0 0 1 1.781-.35c.302.095.577.264.801.493.224.23.391.51.486.82a2.055 2.055 0 0 1-.326 1.836 1.953 1.953 0 0 1-.737.59M5 19.5h14"
      />
    </svg> */}
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m19 16.5-1.677-1.495a.385.385 0 0 0-.423-.076.392.392 0 0 0-.17.15.409.409 0 0 0-.063.22v.4a.812.812 0 0 1-.228.567.767.767 0 0 1-.55.234h-1.556a.767.767 0 0 1-.55-.234.812.812 0 0 1-.227-.566c0-2.036-3.105-3.176-6.612-3.2-.515 0-1.01.21-1.374.585A2.03 2.03 0 0 0 5 14.5c0 .53.205 1.04.57 1.414.364.375.859.586 1.374.586 3.23 0 3.691-9.037 4.44-10.8.127-.299.322-.56.569-.763a1.892 1.892 0 0 1 1.781-.35c.302.095.577.264.801.493.224.23.391.51.486.82a2.055 2.055 0 0 1-.326 1.836 1.953 1.953 0 0 1-.737.59M5 19.5h14"
      />
    </svg>
  </SvgIcon>
);
